import React, { useState } from 'react';
import inventory from "../assets/portfolio/inventory.webp";
import bricks from "../assets/portfolio/bricks.webp";
import facebook from "../assets/portfolio/facebook.webp";
import food from "../assets/portfolio/food.webp";
import lemongrass from "../assets/portfolio/lemongrass.webp";
import news from "../assets/portfolio/news.webp";
import pizza from "../assets/portfolio/pizza.webp";
import portfolio from "../assets/portfolio/portfolio.webp";
import spareparts from "../assets/portfolio/spareparts.webp";
import adorable from "../assets/portfolio/adorable.webp";
import dgs from "../assets/portfolio/dgs.webp";
import dreamprints from "../assets/portfolio/dreamprints.webp";
import { Link } from 'react-router-dom';

const Portfolio = () => {
    const [open, setOpen] = useState(false);

    const portfolios = [
        { id: 1, src: inventory, text: "Inventory Management App" },
        { id: 2, src: portfolio, text: "Portfolio App" },
        { id: 3, src: food, text: "Food Ordering Website" },
        { id: 4, src: spareparts, text: "Showroom Management App", link: "https://axiomaticspares.com" },
        { id: 5, src: bricks, text: "Bengal Bricks Nandakumar", link: "https://bengalbricks.netlify.app" },
        { id: 6, src: facebook, text: "Facebook Clone App" },
        { id: 7, src: lemongrass, text: "Tea Garden Website" },
        { id: 8, src: pizza, text: "Pizza Delivery App" },
        { id: 9, src: news, text: "News Website / App" },
        { id: 10, src: adorable, text: "Tourism Website", link: "https://adorablevacation.com" },
        { id: 11, src: dgs, text: "Companies Profile", link: "https://dgsinfotech.netlify.app" },
        { id: 12, src: dreamprints, text: "E-commerce Website", link: "https://dreamprints.in" },
    ];

    const handleClick = (link) => {
        if (link) {
            window.open(link, '_blank'); // Opens the link in a new tab
        } else {
            setOpen(true); // Opens the modal
        }
    };

    return (
        <div name="portfolio" className="bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-auto pt-28">
            <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
                <div className="pb-10" data-aos="fade-right" data-aos-duration="1800">
                    <h2 className="text-5xl inline border-b-4 border-gray-500">Portfolio</h2>
                    <p className="text-xl mt-20 text-gray-400">Check out some of my work right here</p>
                </div>

                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0" data-aos="fade-up" data-aos-duration="2000">
                    {portfolios.map(({ id, src, text, link }) => (
                        <div key={id} className="shadow-md shadow-gray-400 rounded-lg">
                            <div className="relative block bg-black group rounded-lg">
                                <img className="absolute overflow-hidden inset-0 object-cover w-full h-full md:min-h-full group-hover:opacity-50 rounded-lg" src={src} alt={text} />
                                <div className="relative p-5">
                                    <div className="mt-5 md:mt-14">
                                        <div className="transition-all transform translate-y-8 opacity-0 group-hover:opacity-100 group-hover:translate-y-0">
                                            <div className="p-2">
                                                <p className="text-sm md:text-md text-white"><strong>{text}</strong></p>
                                                <button
                                                    className="px-4 py-2 text-sm text-white bg-gradient-to-b from-cyan-500 to-blue-500 rounded-lg"
                                                    onClick={() => handleClick(link)}
                                                >
                                                    Visit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {open && (
                        <div className="fixed inset-0 flex justify-center items-center overflow-x-hidden overflow-y-auto bg-black/30 backdrop-blur-sm z-50">
                            <div className="relative w-auto my-6 mx-auto max-w-xl">
                                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none">
                                    <div className="flex items-start justify-between md:p-5 p-3 border-b border-solid border-gray-300 rounded-t">
                                        <h3 className="md:text-3xl font-semibold text-black">🙏 Welcome</h3>
                                        <button
                                            className="bg-transparent border-0 text-black float-right"
                                            onClick={() => setOpen(false)}
                                        >
                                            <span className="text-black opacity-7 h-6 w-6 md:text-3xl text-xl block">x</span>
                                        </button>
                                    </div>
                                    <div className="relative p-2 md:p-6 flex-auto">
                                        <div className="shadow-md shadow-gray-600 rounded-lg text-black p-5">
                                            <h2 className="animate-text bg-gradient-to-r from-teal-500 via-purple-500 to-orange-500 bg-clip-text text-transparent md:text-5xl font-black">
                                                Processing...<br />
                                                Under Development!
                                            </h2>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end p-2 md:p-6 border-t border-solid border-blueGray-200 rounded-b">
                                        <button
                                            className="text-white bg-red-600 active:bg-red-800 font-bold uppercase text-sm md:px-6 md:py-3 px-4 py-1 rounded shadow hover:shadow-lg outline-none"
                                            type="button"
                                            onClick={() => setOpen(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
               


                <div className='w-full py-10  text-center'>  
                <Link to="/portfolios" className="relative p-0.5 inline-flex items-center justify-center font-bold overflow-hidden group rounded-md">
    <span className="w-full h-full bg-gradient-to-br from-indigo-500 via-indigo-400 to-pink-500 group-hover:from-indigo-500 group-hover:via-[#ff5478] group-hover:to-[#ff8a05] absolute"></span>
    <span className="relative px-6 py-3 transition-all ease-out bg-gray-900 rounded-md group-hover:bg-opacity-0 duration-400">
        <span className="relative text-white">View More ➟</span>
    </span>
</Link>
                </div>
            </div>
            
        </div>
        
    );
}

export default Portfolio;
